
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { AssignmentGridDataService } from 'common/services/data-services/admin/assignment/assignment-grid-data.service';
import { environment } from 'src/environments/environment';

import { API_URL } from 'common/constants/sm-constants';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { AssignmentGridMetaModel } from 'common/models/page-models/Assignments Model/assignment-grid-meta.model';
import { AssignmentListingModel } from 'common/models/page-models/Assignments Model/assignment-params.model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';


@Injectable({
    providedIn: 'root'
})
export class AssignmentGridWidgetService extends GridWidgetService<AssignmentModel, AssignmentListingModel> {
    constructor(protected override ds: AssignmentGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new AssignmentGridMetaModel().getMetaModel();
        return meta;
    }
    


    async getFilterOptions(filterMetaModel: any) {
        const urlList = [{ url: environment.apiUrl + API_URL.getBatchList, payload: '' }, { url: environment.apiUrl + API_URL.locationGrid, payload: '' }, { url: environment.apiUrl + API_URL.zoneList, payload: '' }, { url: environment.apiUrl + API_URL.getTypeList, payload: '' }];
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            // console.log(data,'getFilterOptions');
            
            filterMetaModel.properties.selectedBatch.options = (data[0]).details;
            filterMetaModel.properties.selectedLocation.options = (data[1]).details;
            filterMetaModel.properties.selectedRegion.options = (data[2]).details;
            filterMetaModel.properties.selectedType.options = (data[3]).details;
        })
    }

    async exportToExcel(filterResults):Promise<any> {
        let exceData;
        const urlList = [{
            url: environment.apiUrl + API_URL.getAssignemntList,
            payload: this.systemService.convertFormData({
                search_keyword: filterResults.selectedBatch?filterResults.selectedBatch:'',
                region_search: filterResults.selectedRegion?filterResults.selectedRegion:'',
                batch_search: filterResults.selectedBatch?filterResults.selectedBatch:'',
                location_search: filterResults.selectedLocation?filterResults.selectedLocation:'',
                type_search: filterResults.selectedType?filterResults.selectedType:'',
                status_text: filterResults.selectedStatus?filterResults.selectedStatus:''
            })
        }];
        
         await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data)=>{
            exceData=data;
            
        });
       return exceData;
    }


    override  prepareMetaModel(dataModel: DataModel, metaModel: SmMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
        return new Promise<SmMetaModel>((resolve, reject) => {

            
          resolve(metaModel);
        });
      }


 

}

